/**
 * ч.1120 — заборона змін: окрема дата організації (не закриття місяця).
 *
 * Проводки з датою до `lock_date` включно не можна додавати, змінювати чи
 * видаляти. Закриття місяця дату не пересуває — бухгалтер ставить її сам.
 * (До ч.1120 тут був клієнт старої сторінки закриття — її прибрано.)
 */
import { api } from './client';

export interface PeriodLock {
  organization_id: string;
  /** YYYY-MM-DD або null — заборони немає. */
  lock_date: string | null;
  set_at: string | null;
  set_by_name: string | null;
  /** Кінець останнього закритого місяця, якщо він ще не захищений (підказка). */
  suggested_lock_date: string | null;
}

export const periodLock = {
  get: (organizationId: string) =>
    api.get<PeriodLock>('/closing/period-lock', {
      params: { organization_id: organizationId },
    }).then((r) => r.data),
  /** `lockDate = null` — зняти заборону. */
  set: (organizationId: string, lockDate: string | null) =>
    api.put<PeriodLock>('/closing/period-lock', { lock_date: lockDate }, {
      params: { organization_id: organizationId },
    }).then((r) => r.data),
};
